import { AriaListBoxOptions, useListBox, useOption } from "@react-aria/listbox";
import { SelectState } from "@react-stately/select";
import React from "react";
import { Typography } from "../Typography/Typography";
import { cn } from "../cn";
import { Node } from "@react-types/shared";

type TPickerListBoxProps = {} & AriaListBoxOptions<object> & {state: SelectState<object>} & {listBoxRef?: React.RefObject<HTMLUListElement>};

export const PickerListBox = (props: TPickerListBoxProps) => {
  let ref = React.useRef(null);
  let { listBoxRef = ref, state } = props;
  let { listBoxProps } = useListBox(props, state, listBoxRef);

  return (
    <ul
      {...listBoxProps}
      ref={listBoxRef}
      className='w-full max-h-72 overflow-auto outline-none'
    >
      {[...state.collection].map((item) => (
        <Option
          key={item.key}
          item={item}
          state={state}
        />
      ))}
    </ul>
  );
}

function Option({ item, state }: {item: Node<object>, state: SelectState<object>}) {
  let ref = React.useRef(null);
  let { optionProps, isSelected, isFocused, isDisabled } = useOption(
    { key: item.key },
    state,
    ref
  );

  return (
    <li
      {...optionProps}
      ref={ref}
    >
      <Typography
        className={cn(
          'flex items-center justify-between p-2 px-3 gap-2 cursor-pointer text-base leading-6 text-text bg-surface',
          isFocused && 'bg-surface-dark',
          isSelected && 'font-bold',
        )}
        weight='semibold'
      >
        {item.rendered}
      </Typography>
    </li>
  );
}